module.exports = __webpack_public_path__ + "static/img/6.c0e2071.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos/6.jpg
// module id = Oj/C
// module chunks = 0